import { css } from 'styled-components';

export const modalHeadingStyles = css`
  margin-block-start: 0;
`;
